<template>
  <div class="layout-wrapper">
    <div class="grid grid-nogutter layout-main-container">
      <div class="layout-app-sidebar">
        <sidebar-app :menus="sidebarItems" :isOpen="isOpen" :showmenu="showmenu"/>
      </div>
      <div class="layout-app">
        <NavbarApp></NavbarApp>
        <div class="layout-app-main">
          <router-view class="col"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SidebarApp from '@/components/layout/sidebar-app/sidebar-app.vue';
import NavbarApp from '@/components/layout/navbar-app/navbar-app.vue'; 
import { layoutMixin } from '@/mixins/layout.mixin';

export default defineComponent({
  name: 'Layout',
  components: {
    SidebarApp,
    NavbarApp
  },
  mixins: [layoutMixin],
  data() {
    return {
      showmenu: false,
      isOpen: false,
      showSide: true,
    };
  },
});
</script>

<style src="./layout.scss" lang="scss" scoped />
